export const settings = {
  version: '2.4.5'
}
